// Copyright ©️ 2026 eVolve MEP, LLC

import type { CSSProperties } from 'react';

const defaultStyle: CSSProperties = {
  flex: 1,
  overflowX: 'auto',
  overflowY: 'scroll',
  minWidth: '500px',
  padding: 0,
  backgroundColor: 'white',
};

export type HTMLRendererProps = {
  /** Untrusted HTML (e.g. a stored message/email body) to render. */
  html: string;
  /** Optional style override for the rendering iframe. */
  style?: CSSProperties;
  /**
   * If true, will allow the execution of scripts inside the iframe.
   *
   * @defaultValue false
   *
   * @remarks Dangerous. Only enable this if you fully trust the HTML content being rendered.
   */
  allowScripts?: boolean;
};

/**
 * Renders an HTML string (such as a stored message/email body) inside a sandboxed iframe.
 *
 * 'allow-scripts' is disabled by default to prevent the execution of potentially unsafe scripts within the iframe.
 */
export const HTMLRenderer = ({ html, style = defaultStyle, allowScripts = false }: HTMLRendererProps) => (
  <iframe
    title="Message content"
    sandbox={`allow-popups allow-popups-to-escape-sandbox ${allowScripts ? 'allow-scripts allow-same-origin allow-presentation' : ''}`}
    srcDoc={html.replaceAll('\r', '')}
    style={style}
  />
);
